module.exports = "https://cdn.hellotech.com/client-assets/online-support_18d4509a4b03f26f0ab0faab6ccdeb3c.svg";